import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { auth } from '../client/FirebaseClient';
import {
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { API_ENDPOINT } from '../constants';
import { GoonAPIClient } from '../client/ApiClient';

@customElement('signup-component')
export class SignupComponent extends LitElement {
  createRenderRoot() {
    return this;
  }

  @state() private email = '';
  @state() private password = '';
  @state() private error = '';

  private async handleSigninUser(userCredential: any) {
    try {
      const token = await userCredential.user.getIdToken();
      await (new GoonAPIClient(API_ENDPOINT)).signin(token)
      this.close()

      this.dispatchEvent(new CustomEvent('auth-state-changed', { bubbles: true, composed: true }));
    } catch (err) {
      this.error = 'Server sign-in failed';
    }
  }

  close() {
    this.dispatchEvent(new CustomEvent('close-auth-modal'));
  }

  private async handleSignup() {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, this.email, this.password);
      await this.handleSigninUser(userCredential);
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  private async handleLogin() {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password);
      await this.handleSigninUser(userCredential);
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  private async handleGoogle() {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      await this.handleSigninUser(result);
    } catch (err) {
      this.error = (err as Error).message;
    }
  }

  render() {
    return html`
      <div class="card shadow p-4 space-y-4">
        <input
          type="email"
          placeholder="Email"
          @input=${(e: any) => (this.email = e.target.value)}
          class="input input-bordered w-full"
        />
        <input
          type="password"
          placeholder="Password"
          @input=${(e: any) => (this.password = e.target.value)}
          class="input input-bordered w-full"
        />
        <div class="flex gap-2">
          <button class="btn btn-primary w-1/2" @click=${this.handleSignup}>Sign Up</button>
          <button class="btn btn-outline w-1/2" @click=${this.handleLogin}>Log In</button>
        </div>

        <div class="divider">OR</div>

        <button class="btn bg-white text-black w-full" @click=${this.handleGoogle}>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            class="w-6"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            style="display: block;"
          >
            <path
              fill="#EA4335"
              d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            ></path>
            <path
              fill="#4285F4"
              d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            ></path>
            <path
              fill="#FBBC05"
              d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            ></path>
            <path
              fill="#34A853"
              d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            ></path>
            <path fill="none" d="M0 0h48v48H0z"></path>
          </svg>
          Sign in with Google
        </button>
        ${this.error ? html`<div class="text-error">${this.error}</div>` : ''}
      </div>
    `;
  }
}

